export default {"src":"/_next/static/media/maze.2023ceaa.gif","height":720,"width":1280};